export const getShortDescr = (descr: string | string[] | null) => {
  if (descr === null) {
    return '';
  }
  if (descr instanceof Array) {
    return descr.slice(0, 4);
  }
  let findDot = 0;
  let findExcl = 0;

  const firstDot = descr.indexOf('.');

  findDot = descr[firstDot - 1] === 'г' ? descr.indexOf('.', firstDot + 1) : firstDot;

  findExcl = descr.indexOf('!');

  if (findExcl > 0 && findDot > 0) {
    return descr.slice(0, (findDot < findExcl ? findDot : findExcl) + 1);
  }
  if (findExcl <= 0 && findDot > 0) {
    return descr.slice(0, findDot + 1);
  }
  if (findDot <= 0 && findExcl > 0) {
    return descr.slice(0, findExcl + 1);
  }

  return '';
};
